import {
  VARIANT_K12_DWB,
  VARIANT_K8_CORE,
} from 'components/SiteUserTrainingGrid/constants'

export const TRAINING_REPORT_SLUG_CORE = 'core'
export const TRAINING_REPORT_SLUG_DWB = 'digital-well-being'

export function trainingReportSlugToVariant(slug) {
  if (slug === TRAINING_REPORT_SLUG_DWB) {
    return VARIANT_K12_DWB
  }
  return VARIANT_K8_CORE
}

export function trainingReportVariantToSlug(variant) {
  return variant === VARIANT_K12_DWB
    ? TRAINING_REPORT_SLUG_DWB
    : TRAINING_REPORT_SLUG_CORE
}

export const trainingReportPath = (reportSlug, siteId) =>
  `/training-report/${reportSlug}/${siteId}`
